import React, { memo } from "react";
import {
   Modal,
   ModalOverlay,
   ModalContent,
   ModalBody,
   ModalCloseButton,
   Button,
   Flex,
   Text,
   useBoolean,
} from "@chakra-ui/react";
import { WarningIcon } from "@/icon/WarningIcon";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { setVersionLevel } from "@/services/user";
import { setUserInfoLevelAction } from "@/components/profile/store/action";
import { useNavigate } from "react-router-dom";

export default memo(function PricingModal({ isOpen, onClose, type }) {
   const dispatch = useDispatch()
   const navigate = useNavigate()
   const [isLoading,setLoading] = useBoolean(false)

   const {id,vip_level,twitter_screen_name} = useSelector(state => ({
      id:state.user.id,
      vip_level:state.user.vip_level,
      twitter_screen_name:state.user.twitter_screen_name
   }), shallowEqual);
   function showHadSetProComponent() {
      return (
         <>
            <Text mt={"30px"} fontSize={{base:16,BREAK_LPC:20}} color="black" textAlign={"center"}>
               {vip_level===1?'Your bot is Standard Version. Upgrade to Pro Version to enjoy data from more marketplaces and smart contracts, as well as bids data and customised sales report.':'Your bot is Pro Version. Switching back to Standard Version will decrease the number of marketplaces and smart contracts supported. No more bids data and customised sales report. '}
            </Text>
            <Flex w={'full'}>
               <Button
                  fontSize={14}
                  color="#333"
                  h={"48px"}
                  mt={"32px"}
                  flex={1}
                  type="email"
                  onClick={onClose}
                  backgroundColor={'#F9F9F9'}
                  borderColor={'#E6E6E6'}
                  alignSelf="center"
                  variant={"outline"}
                  borderRadius={"24px"}>
                  Cancel
               </Button>

               <Button
                  ml="20px"
                  fontSize={14}
                  color="white"
                  h={"48px"}
                  flex={1}
                  mt={"32px"}
                  isLoading={isLoading}
                  onClick={e => {
                     setLoading.on()
                     changeVersion(vip_level === 2 ? 1 : 2)
                  }}
                  type="email"
                  alignSelf="center"
                  colorScheme={"green"}
                  borderRadius={"24px"}>
                  Continue
               </Button>
            </Flex>
         </>
      );
   }
   async function changeVersion(version) {
      const res = await setVersionLevel(id, version);
      if (res.code === 0) {
         dispatch(setUserInfoLevelAction(version))
         navigate(`/${twitter_screen_name}/mybot/set`);
      }
      setLoading.off()
   }
   function showHasProMemberCompoennt() {
      return (
         <>
            <Text mt={"30px"} fontSize={{base:16,BREAK_LPC:20}} color="black" textAlign={"center"}>
               AlohaBots Pro Version has included all features of Standard Version.
            </Text>
            <Button
               fontSize={14}
               color="white"
               h={"48px"}
               w={"160px"}
               mt={"32px"}
               type="email"
               alignSelf="center"
               onClick={onClose}
               colorScheme={"green"}
               borderRadius={"24px"}>
               OK
            </Button>
         </>
      );
   }

   return (
      <Modal
         isOpen={isOpen}
         onClose={onClose}
         blockScrollOnMount={false}
         isCentered
         size={{ base: "xs", BREAK_PAD: "md", BREAK_LPC: "xl" }}>
         <ModalOverlay />
         <ModalContent>
            <ModalCloseButton _focus={{ boxShadow: "none" }} color={"#999"} />
            <ModalBody px={{base:'30px',BREAK_LPC:'60px'}} pt={"30px"} pb={"40px"}>
               <Flex flexDir="column" w={"full"} alignItems="center">
                  <WarningIcon boxSize="34px" />
                  {!type ? showHadSetProComponent() : showHasProMemberCompoennt()}
               </Flex>
            </ModalBody>
         </ModalContent>
      </Modal>
   );
});
